module.exports = __webpack_public_path__ + "static/media/createAgent.f1ada661.png";